export enum CharityRegulator {
  CharityCommissionForEnglandAndWales = 1,
  OfficeOfTheScottishCharityRegulator = 2,
  CharityCommissionNorthernIreland = 3,
}
